import React, { useEffect, useState, Fragment,useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import GateCard from 'components/sales/cardSection/gateCard/gateCard';
import { MrfStatus } from 'components/installation/mrfStatus/mrfStatus';
import ModalPop from 'components/sales/modal/modal';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import { Button } from 'react-bootstrap';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import { ConsolidateReport } from 'components/installation/consolidateReport/consolidateReport';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { Link } from "react-router-dom";
// import './siteInspection.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardSectionNew from 'components/sales/cardSection/cardSection';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import ProductInventory from "components/sales/formSection/productInventory/productInventorySolution";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from 'components/sales/divLayout/divLayout';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModuleInspection';
import {tagMismatchApprove} from "../../../services/redux/approvals/salesApprovals/action";


const TagMismatchDetails = ({
                                 tagApprovalDetails,
                                 siteData,
                                 match,
                                 history,
                                 location,
                                 tagMismatchApprove,
                                 tagMismatchReject,
                               }) => {
  const [modalFlag, setModalFlag] = useState(null);
  const [isModal, setIsModal] = useState(null);
  const [modalMsg, setModalMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    if (
      tagApprovalDetails !== null &&
      match.params.id
    )
      (async () => {
        setIsLoading(true);
        await tagApprovalDetails(match.params.id);
        setIsLoading(false);
      })();
  }, [tagApprovalDetails, match.params.id]);

  const handleModalHide = () => setModalFlag(null);

  const finalSubmit = async (inspection_id) => {
    if(inspection_id){
      const data = {
        inspection_id: match.params.id,
      };

      setModalMsg('Approved!');
      setIsLoading(true);
      const res = await tagMismatchApprove(data);
      setIsLoading(false);
      if (res) {
        setIsModal(true);
      }
    }

  }

  const submitForReject = async (inspection_id) => {

    if(inspection_id){
      const data = {
        inspection_id: match.params.id,
        remarks: remarks.remarks,
      };
      setModalMsg('Rejected!');
      setIsLoading(true);
      const res = await tagMismatchReject(data);
      setIsLoading(false);
      // console.log(res);
      if (res) {
        setIsModal(true);
      }
    }

  }

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <Layout
      title={`Tag Mismatch Details`}
      status={location.state && location.state.status}
      isGoback
      isLoading={isLoading}
      linkFlag={true}
      linkUrl={`/dashboard/tag_mismatch_approvals`}
    >
      {siteData && siteData.details &&
        <>
          <div className="col-md-12 col-xs-12">
            <h4>{siteData.other_data.client_name} ({siteData.other_data.site_no})</h4>
          </div>
          <div className="col-md-3"></div>
        </>
      }

      <FormSection title={'Requirement'}>
        <div className="details-listing">
          { siteData && siteData.details &&
            <>
              <table style={{border:'1px solid',width : '100%'}}>
                <tr style={{border:'1px solid',backgroundColor:'#2f80ed',color:'#fff'}}>
                  <th style={{border:'1px solid',padding:'6px'}}>{localization.tags}</th>
                  <th style={{border:'1px solid',padding:'6px'}}>{localization.unitPrice}</th>
                  <th style={{border:'1px solid',padding:'6px'}}>Sales Qty</th>
                  <th style={{border:'1px solid',padding:'6px'}}>{localization.opsQty}</th>
                </tr>

                {siteData.details.map((obj, index) => {
                  return(
                    <>
                      {obj.qty === obj.receive_qty ?
                        <tr key={index}>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.name}</td>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.price}</td>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.qty}</td>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.receive_qty}</td>
                        </tr>
                        :
                        <tr key={index} style={{"backgroundColor":"#ffe6e6"}}>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.name}</td>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.price}</td>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.qty}</td>
                          <td style={{border:'1px solid',padding:'6px'}}>{obj.receive_qty}</td>
                        </tr>
                      }

                      {/* {console.log(obj)} */}

                    </>

                  );

                })}
              </table>
            </>

          }
        </div>
      </FormSection>
      <hr/>

      {(siteData && siteData.other_data && siteData.other_data.status === 0) ?
        <>

          <div className='col-md-12 text-center'>
            <Button
              className={`mb-4`}
              onClick={() => {
                finalSubmit(match.params.id)
              }}
            >
              Approve
            </Button>

            {/* </div>
              <div className='col-md-12 text-center'> */}
            <Button
              className={`ml-4 mb-4`}
              onClick={() => {
                setShowRejectModal(true);
                // submitForReject(match.params.id)
              }}
            >
              Reject
            </Button>

          </div>

        </>
        :
        (siteData && siteData.other_data && siteData.other_data.status === 1) ?
          <div className='col-md-12 text-center'>
            <h3 style={{"color":"green"}}>Approved</h3>

          </div>
          :
          <div className='col-md-12 text-center'>
            <h3 style={{"color":"Red"}}>Rejected</h3>

          </div>
      }

      <ModalPop
        title={`Final Submitted`}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <>
            {/* inspection_approvals */}
            <h5>{modalMsg}</h5>
            <Link
              to={`${baseUrl}/tag_mismatch_approvals`}
              className="btn btn-primary mb-4"
            >
              {localization.goToApprovalListing}{" "}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.rejectConf}
        show={showRejectModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <Fragment>
          <div className="modal-body">
            <div className="text-center">
              <h5>{localization.rejectTagMismatch}</h5>
              <div className="form-group">
                <ConstantInput
                  label={localization.addRemark}
                  required
                  isStarRequired={true}
                  type="text"
                  handleChange={(val) => {
                    setRemarks({ ...setRemarks, remarks: val });
                  }}
                />
              </div>
              <Button
                className="btn btn-primary"
                onClick={() => {
                  submitForReject(match.params.id)
                }}
                disabled={!remarks.remarks}
              >
                {localization.continue}{' '}
                <img src="../images/arrow-right.png" alt="" />
              </Button>
            </div>
          </div>
        </Fragment>
      </ModalPop>

    </Layout>
  );
};
export default TagMismatchDetails;
